import styled from 'styled-components'
import theme from '../../../theme/theme'

type Props = {
  children: JSX.Element | JSX.Element[]
  onClick?: ((event: any) => void) | undefined
  disabled?: boolean
}

const StyledActionIcon = styled.a<{ disabled?: boolean }>`
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`


function ActionIcon({ children, onClick, disabled = false }: Props) {
  return (
    <StyledActionIcon onClick={disabled ? undefined : onClick} disabled={disabled}>
      {children}
    </StyledActionIcon>
  )
}

export default ActionIcon
